import { Badge } from "@/components/ui/badge";

// Shared status pill for both the Team and Partner-users tables.
//   active    → calm/neutral
//   suspended → destructive
//   invited   → outline (pending)
export function UserStatusBadge({
  status,
}: {
  status: "active" | "suspended" | "invited";
}) {
  if (status === "suspended") {
    return <Badge variant="destructive">Suspended</Badge>;
  }
  if (status === "invited") {
    return (
      <Badge variant="outline" className="border-amber-500/40 text-amber-600 dark:text-amber-400">
        Invited
      </Badge>
    );
  }
  return (
    <Badge variant="outline" className="border-emerald-500/40 text-emerald-600 dark:text-emerald-400">
      Active
    </Badge>
  );
}
